import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import InspectionPage from './InspectionPage';
import EndLineHistory from './EndLineHistory';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import './Dashboard.css';

const DashboardHeader = ({ isSidebarOpen, setIsSidebarOpen, user, handleLogout, customerLogo, brandLogo }) => {
  const FRAPPE_URL = process.env.REACT_APP_FRAPPE_URL || 'http://pra.localhost:8000';
  const { isOnline, isBackendAvailable } = useOnlineStatus();
  
  return (
    <header className="common-header">
      <div className="header-left">
        <button 
          className="hamburger-button"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
        <div className="logo-section">
          <img 
            src="/pragyaa-logo.png"
            alt="Pragyaa Apparels" 
            className="app-logo"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextElementSibling.style.display = 'block';
            }}
          />
          <h1 className="app-title" style={{ display: 'none' }}>Pragyaa Apparels</h1>
        </div>
      </div>
      
      {/* Customer and Brand Logos */}
      <div className="client-logos">
        {customerLogo && (
          <img 
            src={`${FRAPPE_URL}${customerLogo}`}
            alt="Customer Logo" 
            className="client-logo customer-logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        )}
        {brandLogo && (
          <img 
            src={`${FRAPPE_URL}${brandLogo}`}
            alt="Brand Logo" 
            className="client-logo brand-logo"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        )}
      </div>
      
      <div className="user-info">
        <span className="welcome-text">
          {user?.full_name || user?.name || user?.username || 'User'}
        </span>
        <button 
          onClick={handleLogout} 
          className="logout-button"
          disabled={!isOnline || !isBackendAvailable}
          title={!isOnline || !isBackendAvailable ? "Cannot sign out - backend unavailable" : "Sign Out"}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Sign Out
        </button>
      </div>
    </header>
  );
};

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();
  
  const handleLinkClick = () => {
    setIsOpen(false);
  };
  
  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div 
          className="sidebar-overlay"
          onClick={() => setIsOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <nav className="sidebar-nav">
          <Link 
            to="/inspection" 
            className={`sidebar-link ${location.pathname === '/inspection' || location.pathname === '/' ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            <span className="sidebar-icon">📋</span>
            <span className="sidebar-text">Inspection</span>
          </Link>
          <Link 
            to="/history" 
            className={`sidebar-link ${location.pathname === '/history' ? 'active' : ''}`}
            onClick={handleLinkClick}
          >
            <span className="sidebar-icon">📊</span>
            <span className="sidebar-text">History</span>
          </Link>
        </nav>
      </aside>
    </>
  );
};

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [customerLogo, setCustomerLogo] = useState(null);
  const [brandLogo, setBrandLogo] = useState(null);
  
  // Get user from localStorage
  const storedUser = JSON.parse(localStorage.getItem('frappe_user') || '{}');
  const user = storedUser;
  
  const handleLogout = () => {
    localStorage.removeItem('frappe_logged_in');
    localStorage.removeItem('frappe_user');
    localStorage.removeItem('frappe_user_line');
    window.location.reload();
  };
  
  return (
    <Router>
      <div className="dashboard-wrapper">
        <DashboardHeader 
          isSidebarOpen={isSidebarOpen} 
          setIsSidebarOpen={setIsSidebarOpen}
          user={user}
          handleLogout={handleLogout}
          customerLogo={customerLogo}
          brandLogo={brandLogo}
        />
        <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
        <main className="dashboard-content">
          <Routes>
            <Route path="/" element={<InspectionPage hideHeader={true} hideStatsBar={false} onLogoChange={{ setCustomerLogo, setBrandLogo }} />} />
            <Route path="/inspection" element={<InspectionPage hideHeader={true} hideStatsBar={false} onLogoChange={{ setCustomerLogo, setBrandLogo }} />} />
            <Route path="/history" element={<EndLineHistory />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default Dashboard;